export default "__VITE_ASSET__DWnWJYQ7__"